import React from "react"
import { ProgressSpinner } from "primereact/progressspinner"
import { ProgressBar } from "primereact/progressbar"

import styles from "../../styles/Loader.module.css"

export function LoaderSmall() {
  return (
    <div className={styles.wrapperSm}>
      <ProgressSpinner
        className={styles.spinnerSm}
        strokeWidth="4"
        animationDuration=".2s"
      />
    </div>
  )
}

export function LoaderProgressBarSideWide() {
  return (
    <div className={styles.progressBarSideWideWrapper}>
      <ProgressBar
        mode="indeterminate"
        className={styles.progressBarThin}
      ></ProgressBar>
    </div>
  )
}

export function LoaderProgressBar() {
  return (
    <div>
      <ProgressBar mode="indeterminate" className={styles.progressBarThin}></ProgressBar>
    </div>
  )
}

export function LoaderMedium() {
  return (
    <div className={styles.wrapperMed}>
      <ProgressSpinner
        className={styles.spinnerMed}
        strokeWidth="4"
        animationDuration=".4s"
      />
    </div>
  )
}

export default function LoaderFullPage() {
  return (
    <div className={styles.wrapperFull}>
      <ProgressSpinner
        className={styles.spinnerFull}
        strokeWidth="4"
        animationDuration=".4s"
      />
    </div>
  )
}
